"use client";

import { Lightbulb, MessageCircleMore } from "lucide-react";
import { usePathname } from "next/navigation";
import React from "react";
import { useScrollToSection } from "@/components/hooks/use-scroll-to-section";
import { Button } from "@/components/ui/button";
import { Hero as HeroBase } from "@/components/ui/Hero";
import { Marketing360Form } from "@/components/ui/Marketing360Form";
import { MotionLink } from "@/components/ui/Motion";
import { URLS } from "@/lib/consts";
import { cls, getServicePath } from "@/lib/utils";
import HERO_SECTION_CONTENT, {
  CTA_BUTTON_TEXT,
  HERO_HREF,
  SECONDARY_BUTTON_TEXT,
} from "./consts";

export default function Hero() {
  const pathname = usePathname();
  const handleOnClick = useScrollToSection(HERO_HREF);
  const servicePath = getServicePath(pathname);

  if (!servicePath) {
    return null;
  }

  const { title, description } = HERO_SECTION_CONTENT[servicePath];

  const serviceFormIds: Record<string, string> = {
    '/services/design-and-build': '69bc383f7588714014038b22',
    '/services/design-and-renovate': '69bc39c1192358a6c90d4983',
  };
  const formId = serviceFormIds[servicePath];

  const formCard = (
    <div className="bg-[#DDD9CF]/95 backdrop-blur-sm rounded-lg p-4 shadow-xl [zoom:0.6]">
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        Request A Free Consultation
      </h3>
      <Marketing360Form formId={formId} />
    </div>
  );

  return (
    <HeroBase title={title} desc={description} sideContent={formCard} height="min-h-[100vh]">
      <Button className={cls`flex flex-1`} asChild>
        <MotionLink href={URLS.REQUEST_CONSULTATION}>
          <MessageCircleMore />
          {CTA_BUTTON_TEXT}
        </MotionLink>
      </Button>

      <Button
        className={cls`flex flex-1`}
        variant="secondary"
        onClick={handleOnClick}
        asChild
      >
        <MotionLink href={HERO_HREF}>
          <Lightbulb />
          {SECONDARY_BUTTON_TEXT}
        </MotionLink>
      </Button>
    </HeroBase>
  );
}
